import React from 'react';
import { motion } from 'framer-motion';

export interface ExperienceLinkItem {
  label: string;
  href: string;
  image: string;
  imageAlt?: string;
}

interface TwoColumnExperienceLinksProps {
  links: [ExperienceLinkItem, ExperienceLinkItem];
}

const ExperienceLinkCard = ({ link }: { link: ExperienceLinkItem }): JSX.Element => (
  <a
    href={link.href}
    className="group relative block w-full"
  >
    <img
      src={link.image}
      alt={link.imageAlt ?? link.label}
      className="w-full transition-transform duration-500 group-hover:scale-[1.01]"
      loading="lazy"
    />
    <div className="absolute inset-0 flex items-center justify-center bg-black/15 transition-colors duration-300 group-hover:bg-black/30">
      <span className="inline-flex items-center rounded-full border border-[#0048FF] bg-white/90 dark:bg-black/60 backdrop-blur-sm px-5 py-2 text-sm [font-family:'ItemsTextTrial-Light',Helvetica] font-light text-[#0048FF] group-hover:bg-[#0048FF] group-hover:text-white transition-colors duration-200 text-center">
        {link.label}
      </span>
    </div>
  </a>
);

export const TwoColumnExperienceLinks: React.FC<TwoColumnExperienceLinksProps> = ({ links }) => {
  const [left, right] = links;

  return (
    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-10">
      <div className="lg:hidden">
        <ExperienceLinkCard link={left} />
      </div>
      <motion.div
        className="hidden lg:block"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-50px' }}
        transition={{
          duration: 0.6,
          ease: [0.25, 0.46, 0.45, 0.94],
        }}
      >
        <ExperienceLinkCard link={left} />
      </motion.div>

      <div className="lg:hidden">
        <ExperienceLinkCard link={right} />
      </div>
      <motion.div
        className="hidden lg:block"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-50px' }}
        transition={{
          duration: 0.6,
          ease: [0.25, 0.46, 0.45, 0.94],
        }}
      >
        <ExperienceLinkCard link={right} />
      </motion.div>
    </div>
  );
};
